import { AuthenticationPageContainer } from '@/features/user/components'
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined'
import { Avatar, Box, Button, Typography, useTheme } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { UnauthenticatedPage } from '@/components/UnauthenticatedPage/UnauthenticatedPage.tsx'

export const Route = createFileRoute('/reset-password-successful')({
  component: ResetPasswordSuccesComponent
})

function ResetPasswordSuccesComponent() {
  const navigate = Route.useNavigate()
  const theme = useTheme()
  const { t } = useTranslation('_routes')

  return (
    <AuthenticationPageContainer
      advertisingChip={t('routes.reset-password-successful.main.advertising.chip')}
      advertisingTitle={t('routes.reset-password-successful.main.advertising.title')}
      advertisingSubtitle={t(
        'routes.reset-password-successful.main.advertising.subTitle'
      )}
    >
      <UnauthenticatedPage>
        <Box
          sx={{
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            ml: '10%',
            mr: '30%'
          }}
        >
          <Avatar
            sx={{
              width: '50px',
              height: '50px',
              backgroundColor: theme.palette.info.light
            }}
          >
            <DoneOutlinedIcon sx={{ color: theme.palette.primary.main }} />
          </Avatar>

          <Typography sx={{ mt: 3 }} variant="h1" color="primary" component="span">
            {t('routes.reset-password-successful.main.title')}
          </Typography>

          <Typography sx={{ my: 2 }} color="primary" variant="body1">
            {t('routes.reset-password-successful.main.infoBand')}
          </Typography>

          <Box sx={{ mt: 2 }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => navigate({ to: '/login' })}
            >
              {t('routes.reset-password-successful.main.buttonTitle')}
            </Button>
          </Box>
        </Box>
      </UnauthenticatedPage>
    </AuthenticationPageContainer>
  )
}
